import type { PageConfig } from '../../_components/page/pageConfig';
import { getQuotePageTargetingFromPathname } from '../../../src/utils/quote/page-targeting';

type PageConfigRule = {
  match: (pathname: string) => boolean;
  config: PageConfig;
};

const FRONT_PAGE_TARGETING = { pageTargeting: { BZ_PTYPE: 'front' as const } };

const rules: PageConfigRule[] = [
  { match: path => path === '/', config: FRONT_PAGE_TARGETING },
  {
    match: path =>
      path === '/recent' ||
      path === '/stock-ideas' ||
      path === '/briefs' ||
      path === '/exclusives',
    config: FRONT_PAGE_TARGETING,
  },
  { match: path => path === '/quiz/leaderboard', config: { pageTargeting: { BZ_CHANNEL: ['Quiz'], BZ_PTYPE: 'quiz_leaderboard' } } },
  { match: path => path === '/quiz/rules', config: { pageTargeting: { BZ_CHANNEL: ['Quiz'], BZ_PTYPE: 'quiz_rules' } } },
  { match: path => path.startsWith('/quiz'), config: { pageTargeting: { BZ_CHANNEL: ['Quiz'], BZ_PTYPE: 'quiz' } } },
  { match: path => path.startsWith('/tools'), config: { pageTargeting: { BZ_PTYPE: 'tool' } } },
  { match: path => path === '/free-newsletters', config: { pageTargeting: { BZ_PTYPE: 'tool' } } },
  { match: path => path.startsWith('/government-trades'), config: { pageTargeting: { BZ_PTYPE: 'tool' } } },
  { match: path => path === '/short-interest' || path.startsWith('/short-interest/'), config: { pageTargeting: { BZ_CHANNEL: ['Short Interest'], BZ_PTYPE: 'tool' } } },
  { match: path => path === '/calendars' || path.startsWith('/calendars/'), config: { pageTargeting: { BZ_CHANNEL: ['Calendar'], BZ_PTYPE: 'calendar' } } },
  { match: path => path === '/dividends' || path.startsWith('/dividends/'), config: { pageTargeting: { BZ_CHANNEL: ['Calendar'], BZ_PTYPE: 'calendar' } } },
  { match: path => path === '/earnings' || path.startsWith('/earnings/'), config: { pageTargeting: { BZ_CHANNEL: ['Calendar'], BZ_PTYPE: 'calendar' } } },
  { match: path => path === '/fda-calendar' || path.startsWith('/fda-calendar/'), config: { pageTargeting: { BZ_CHANNEL: ['FDA'], BZ_PTYPE: 'channel' } } },
  { match: path => path === '/premarket' || path.startsWith('/premarket'), config: { pageTargeting: { BZ_CHANNEL: ['Premarket'], BZ_PTYPE: 'premarket' } } },
  { match: path => path === '/watch', config: { pageTargeting: { BZ_PTYPE: 'front' } } },
  { match: path => path === '/reviews', config: { pageTargeting: { BZ_CHANNEL: ['Alternative Investments'], BZ_PTYPE: 'channel' } } },
  { match: path => path === '/yield-investments', config: { pageTargeting: { BZ_CHANNEL: ['Yield'], BZ_PTYPE: 'channel' } } },
  { match: path => path === '/podcasts' || path.startsWith('/podcasts/'), config: { pageTargeting: { BZ_CHANNEL: ['Podcasts'], BZ_PTYPE: 'podcasts' } } },
  { match: path => path === '/alternative-investments' || path.startsWith('/alternative-investments/'), config: { pageTargeting: { BZ_CHANNEL: ['Alternative Investments'], BZ_PTYPE: 'channel' } } },
  { match: path => path === '/analyst-stock-ratings' || path.startsWith('/analyst-stock-ratings/'), config: { pageTargeting: { BZ_PTYPE: 'calendar' } } },
  { match: path => path === '/secfilings', config: { pageTargeting: { BZ_CHANNEL: ['SEC Filings'], BZ_PTYPE: 'channel' } } },
  { match: path => path.startsWith('/futures'), config: { pageTargeting: { BZ_CHANNEL: ['Futures'], BZ_PTYPE: 'website' } } },
  { match: path => path.startsWith('/margin-calculator'), config: { pageTargeting: { BZ_CHANNEL: ['Margin'], BZ_PTYPE: 'tool' } } },
  { match: path => path.startsWith('/portfolio/'), config: { pageTargeting: { BZ_CHANNEL: ['Portfolio'], BZ_PTYPE: 'tool' } } },
  { match: path => path === '/razreport', config: { pageTargeting: { BZ_CHANNEL: ['RazReport'], BZ_PTYPE: 'website' } } },
  { match: path => path === '/profile/portfolio' || path.startsWith('/profile/portfolio/'), config: { disablePushPrompt: false } },
  { match: path => path === '/login/close', config: { disablePushPrompt: true } },
  { match: path => path === '/forex-profit-calculator', config: { pageTargeting: { BZ_CHANNEL: ['Forex'], BZ_PTYPE: 'tool' } } },
  { match: path => path === '/edge/dashboard', config: { disableRaptiveFooter: true } },
  { match: path => path.startsWith('/partner-content') || path.startsWith('/sponsored'), config: { headerProps: { disableOptinMonster: true } } },
  { match: path => path === '/services', config: {} },
];

export function resolvePageConfig(pathname: string): PageConfig {
  const quotePageTargeting = getQuotePageTargetingFromPathname(pathname);
  if (quotePageTargeting) {
    return { pageTargeting: quotePageTargeting };
  }

  for (const rule of rules) {
    if (rule.match(pathname)) {
      return rule.config;
    }
  }
  return {};
}
